import React, { useEffect, useState } from 'react';
import { CalendarClock } from 'lucide-react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './ui/dialog';

const STORAGE_KEY = 'w360_vacation_notice_seen';

export const VacationNotice = () => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (!sessionStorage.getItem(STORAGE_KEY)) {
      const t = setTimeout(() => setOpen(true), 800);
      return () => clearTimeout(t);
    }
  }, []);

  const handleChange = (v) => {
    setOpen(v);
    if (!v) sessionStorage.setItem(STORAGE_KEY, '1');
  };

  return (
    <Dialog open={open} onOpenChange={handleChange}>
      <DialogContent className="max-w-md bg-[#F6F2E8] border-[#D6CFB8] rounded-3xl" data-testid="vacation-notice-dialog">
        <DialogHeader>
          <div className="w-14 h-14 rounded-full bg-[#245A40] grid place-items-center mx-auto">
            <CalendarClock className="w-7 h-7 text-[#E8C56B]" />
          </div>
          <DialogTitle className="font-display text-2xl text-[#1B2A22] text-center pt-2">
            We&rsquo;re on vacation!
          </DialogTitle>
          <DialogDescription className="text-center text-[#3F4A42] text-base leading-relaxed pt-1" data-testid="vacation-notice-message">
            We will be on vacation from October 26th through November 4th. We will resume taking orders on November 5th. Thank you for your patience!
          </DialogDescription>
        </DialogHeader>
        <button
          onClick={() => handleChange(false)}
          data-testid="vacation-notice-ok-btn"
          className="mt-2 w-full h-11 rounded-full bg-[#245A40] text-[#F6F2E8] font-semibold hover:bg-[#1B4631] transition-colors"
        >
          Got it
        </button>
      </DialogContent>
    </Dialog>
  );
};
